import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14ee4f39"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "prepend-content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_kbutton = _resolveComponent("kbutton")!

  return (_openBlock(), _createBlock(_component_kbutton, _mergeProps({
    class: "button",
    "theme-color": _ctx.themeColor,
    disabled: _ctx.disabled || _ctx.loading
  }, _ctx.$attrs), {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.t('IButton.loading')), 1))
        : (_ctx.text)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.text), 1))
          : _createCommentVNode("", true)
    ]),
    _: 3
  }, 16, ["theme-color", "disabled"]))
}